<div class="ms-font-l">{{'INTERNAL-NOTE' | translate}}:</div>
<div class="note" (click)="openLink(this.internalNote)" [ngClass]="{'link': this.internalNote.includes('http')}">
    {{this.internalNote}}
</div>